import { useQuery } from '@apollo/client';
import { QueryHookOptions } from '@apollo/client/react/types/types';
import { Query } from 'app-types/desk';

import { GET_UNASSIGNED_AND_UNREAD_TICKETS_IDS_QUERY } from '../../gql/queries';

export function useGetUnassignedAndUnreadTicketsIds(options?: QueryHookOptions) {
  const { data, loading, refetch } = useQuery<{
    Ticket_CountChatTicketsForNotify: Query['Ticket_CountChatTicketsForNotify'];
  }>(GET_UNASSIGNED_AND_UNREAD_TICKETS_IDS_QUERY, {
    ...options,
    context: { ...options?.context, clientName: 'desk' },
  });
  return {
    data: data?.Ticket_CountChatTicketsForNotify,
    loading,
    refetch,
  };
}
